/* eslint-disable */
import React, { useEffect, useState } from "react";
import BossDialog from "../../components/BossDialog";
import * as API from "../../framework/API/api";
import { ENTITYNAME, TOAST_TYPES } from "../../framework/constant/constant";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { EditPageHeader } from "../../components/EditPageHeader";
import { useTranslation } from "../../locale/useTranslation";
import { utility } from "../../framework/utility/utilityProvider";
import ToastNotification from "../../components/ToastNotification";
import { PROMOTIONS_PLATFORM } from "./SocialMediaConstant";

export const PromotionsPageEditForm = (props) => {
    const lang = useTranslation();
    const item = props.item;

    const blankDataItem = {
        ...item,
        Name: item.Name ?? '',
        PromotionsPlatform: item?.PromotionsPlatform ? { _id: item.PromotionsPlatform, Description: utility.getKeyByValue(PROMOTIONS_PLATFORM, item.PromotionsPlatform) } : { _id: PROMOTIONS_PLATFORM.FACEBOOK, Description: utility.getKeyByValue(PROMOTIONS_PLATFORM, PROMOTIONS_PLATFORM.FACEBOOK) },
        AccessToken: item.AccessToken ?? '',
        AccessKey: item.AccessKey ?? '',
        Archive: item?.Archive ?? false,
    };

    const [dataItem, setDataItem] = useState(blankDataItem);
    const [platforms, setPlatforms] = useState([]);

    useEffect(() => {
        loadCombo();
    }, []);

    const loadCombo = async () => {
        const platformRes = Object.keys(PROMOTIONS_PLATFORM).map(x => ({
            _id: PROMOTIONS_PLATFORM[x],
            Description: x
        }));
        setPlatforms(platformRes);
    };

    const isValid = () => {
        if (!dataItem.Name || dataItem.Name.trim() === "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title , message: lang.please_enter_page_name_error_message });
            return false;
        }
        if (!dataItem.AccessToken || dataItem.AccessToken.trim() === "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title , message: lang.please_enter_access_token_error_message });
            return false;
        }
        if (!dataItem.AccessKey || dataItem.AccessKey.trim() === "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title , message: lang.please_enter_access_key_error_message });
            return false;
        }
        return true;
    };

    const handleSubmit = async (e) => {
        if (!isValid()) return;
        const saveData = {
            _id: dataItem._id,
            SID: dataItem.SID,
            Name: dataItem.Name,
            PromotionsPlatform: dataItem.PromotionsPlatform._id,
            AccessToken: dataItem.AccessToken,
            AccessKey: dataItem.AccessKey,
            Archive: dataItem.Archive ?? false,
        };

        let res = await API.saveData(ENTITYNAME.SM_PromotionsPages, saveData);
        if (res.success) {
            utility.deleteLocalStorageItem(ENTITYNAME.SM_PromotionsPages);
            if (props.cancelEdit) props.cancelEdit();
            if (props.refresh) props.refresh();
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title || "Error", message: res.message });
        }
    };

    const onChange = (e) => {
        if (e.target.name === "Archive") {
            setDataItem({ ...dataItem, Archive: !dataItem.Archive });
        } else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }
    };

    return (
        <BossDialog
            title={item?._id ? lang.edit_page_header : lang.create_page_header}
            onClose={props.cancelEdit}
            width={"600px"}
        >
            <EditPageHeader title={""} onSubmit={handleSubmit} onCancel={props.cancelEdit} showTitle={false} />
            <div className="row mt-2 form-group">
                <div className="col-6">
                    <label htmlFor="Name">{lang.name_label} *</label>
                    <input
                        name="Name"
                        type="text"
                        className="form-control form-control-sm"
                        onChange={onChange}
                        value={dataItem.Name}
                    />
                </div>
                <div className="col-6">
                    <label name="PromotionsPlatform">{lang.platform_label} *</label>
                    <DropDownList
                        data={platforms}
                        name="PromotionsPlatform"
                        dataItemKey="_id"
                        textField="Description"
                        onChange={onChange}
                        value={dataItem.PromotionsPlatform}
                        style={{ backgroundColor: 'white', height: '32px' }}
                    />
                </div>
            </div>
            <div className="row mt-2 form-group">
                <div className="col-6">
                    <label name="AccessToken">{lang.access_token_label} *</label>
                    <input
                        name="AccessToken"
                        type="text"
                        className="form-control form-control-sm"
                        onChange={onChange}
                        value={dataItem.AccessToken}
                    />
                </div>
                <div className="col-6">
                    <label name="AccessKey">{lang.access_key_label} *</label>
                    <input
                        name="AccessKey"
                        type="text"
                        className="form-control form-control-sm"
                        onChange={onChange}
                        value={dataItem.AccessKey}
                    />
                </div>
            </div>
            <div className="row form-group mt-2">
                <div className="col">
                    <input
                        type="checkbox"
                        name="Archive"
                        onChange={onChange}
                        value={dataItem.Archive}
                        checked={dataItem.Archive}
                    />
                    <label className="ml-1">{lang.archive_label}</label>
                </div>
            </div>
        </BossDialog>
    );
};
export default PromotionsPageEditForm;
